// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item_font[data-v-7d1405a3]{font-size:14px}[data-size=\"2\"] .item_font[data-v-7d1405a3]{font-size:14px!important}[data-size=\"3\"] .item_font[data-v-7d1405a3]{font-size:16px!important}[data-size=\"4\"] .item_font[data-v-7d1405a3]{font-size:18px!important}[data-v-7d1405a3] .el-table .el-table__body-wrapper{transform:translateZ(0)}", ""]);
// Exports
module.exports = exports;
